import { render, staticRenderFns } from "./departSelect.vue?vue&type=template&id=2a1133e1&"
import script from "./departSelect.vue?vue&type=script&lang=js&"
export * from "./departSelect.vue?vue&type=script&lang=js&"
import style0 from "./departSelect.vue?vue&type=style&index=0&id=2a1133e1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports